export default {
  title: 'Ihre Website ist fertig',
  body_one: 'Reservierungen sind für {{count}} Restaurant noch deaktiviert:',
  body_other: 'Reservierungen sind für {{count}} Restaurants noch deaktiviert:',
  reasons: {
    license_required: 'Benötigt einen Partner Plan',
    notification_email_required:
      'Benötigt eine E-Mail-Adresse für Buchungsbenachrichtigungen. Geben Sie sie beim Aktivieren der Reservierungen an.',
    switched_off: 'In den Reservierungseinstellungen deaktiviert',
    activation_failed:
      'Konnte nicht aktiviert werden. Bitte versuchen Sie es in den Reservierungseinstellungen erneut.',
  },
  buttons: {
    open_settings: 'Reservierungseinstellungen öffnen',
    continue: 'Weiter zum Website-Builder',
  },
};
